// import { lazyImport } from "utils/lazyImport";

import { AuthRoutes } from "features/auth/routes";
import { SignContractRoutes } from "features/signContract/routes";

// const { AuthRoutes } = lazyImport(() => import("features/auth"), "AuthRoutes");

export const PublicRoutes = [
  {
    path: "/authentication/*",
    element: <AuthRoutes />,
  },
  ...SignContractRoutes,
];
